<template>
   <div id="jobHunting" class="jobHunting"> 
       <img :src="list.logo" alt="" class="banner-img" ondragstart="return false;" oncontextmenu="return false;">
        <div class="banner">
            <div class="banner-description">
            <div class="name">{{list.title1}}</div>
             <div class="description">{{list.title1s}}</div>
           </div>
        </div>
           <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup"></i>
                <h1>{{list.title1}}</h1>
                <h3>{{list.title1s}}</h3>
                    <div class="endowloadDetail-description-btn flex align-cen">
                </div>
            </div>
        </div>
        <div class="jobHunting-container">
            <div class="tit-search">
                <el-input
                placeholder="请输入职位关键词"
                clearable
                v-model="search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  <template slot="append">
                    <div class="append-click" @click="getJobList">立即搜索</div>
                  </template>
            </el-input>
            </div>
            <div class="jobHunting-container-fillter">
                <div class="fillter-row flex">
                    <div class="label">工作地点</div>
                    <div class="allWork" :class="{ active: currentNav0 == '-1' }" @click="datafillter1('-1','',0)">不限</div>
                    <div class="work"
                    v-for="(item,index) in workplace"
                    :key="index"
                    :class="{ active: currentNav0 == index }"
                    @click="datafillter(index,item,0)"
                    >
                    {{item}}
                    </div>
                </div>
                 <div class="fillter-row flex">
                    <div class="label">职位类别</div>
                    <div class="allWork" :class="{ active: currentNav2 == '-1' }" @click="datafillter1('-1','',2)">不限</div>
                    <div class="work"
                    v-for="(item,index) in jobClass"
                    :key="index"
                    :class="{ active2: currentNav2 == index }"
                    @click="datafillter(index,item,2)"
                    >
                    {{item.name}}
                    </div>
                </div>
                   <div class="fillter-row flex">
                    <div class="label">招聘类型</div>
                    <div class="allWork" :class="{ active: currentNav1 == '-1' }" @click="datafillter1('-1','',1)">不限</div>
                    <div class="work"
                    v-for="(item,index) in hiringNeeds"
                    :key="index"
                    :class="{ active1: currentNav1 == index }"
                    @click="datafillter(index,item,1)"
                    >
                    {{item}}
                    </div>
                </div>
                <div class="coll">
                    <div class="coll-alljob">全部职位 ({{totalCount}})</div>
                    <el-collapse  v-if="jobList.length"
                    v-model="activeName"
                    accordion
                    >
                    <el-collapse-item
                    v-for="(item,index) in jobList"
                    :key="index"
                    :name="index"
                    >
                        <template slot="title">
                        <div class="job-name">{{item.name}}</div>
                         <div class="job-type flex">
                            {{item.hiringNeeds == '社招' ? '社会' : '校园'}}招聘  
                            {{list.jobCategory}}
                        <div class="job-work"> <i class="el-icon-location"></i> {{item.workplace}}</div>
                            </div>
                            <div class="job-price">薪资：{{item.salaryRange}}</div>
                            <div class="job-time">{{item.updateTime}}  发布</div>
                        </template>
                        <div class="job-desc">
                            <div class="job-desc-tit">
                                职位描述
                            </div>
                            <div class="job-desc-data">
                                <div v-html="item.description"></div>
                            </div>
                        </div>
                          <div class="job-desc">
                            <div class="job-desc-tit">
                                职位要求
                            </div>
                            <div class="job-desc-data">
                               <div v-html="item.requirement"></div>
                            </div>
                        </div>
                        <div class="job-btn" @click="openTd(item.id)">
                            立即投递
                        </div>
                        <div class="job-detail" @click="openDetail(item.id)">
                            查看详情 <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
                        </div>
                    </el-collapse-item>
                    </el-collapse>
                     <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无招聘</p>
        </div>
                </div>
            </div>
        </div>
             <el-dialog
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  top="30vh"
  title="投递简历"
  v-if="centerDialogVisible"
  :show-close="fileId ? false : true"
  >
    <div class="formUp" >
         <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/uploadNoLogin'"
                    :on-success="handleAvatarSuccess1"
                    accept=".pdf,.doc,.docx,.ppt,.pptx,.png,.jpg,.jpeg"
                    drag
                    :file-list="fileList"
                    :on-change="handleChangePic"
                    :on-error="uploadError"
                    :before-upload="beforeUpload"
                    ref="uploadFile"
                    :show-file-list="uploadIs"
                    >
                     <i class="el-icon-upload" ></i>
                     <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                     <div slot="tip" class="el-upload__tip">支持格式：<span style="color:#f56c6c">pdf、doc、docx、ppt、pptx、png、jpg、jpeg</span></div>
                     <div slot="tip" class="el-upload__tip" v-if="resoceUrl">简历地址：<span style="color:#f56c6c">{{resoceUrl}}</span></div>
         </el-upload>
        <div class="subBtn flex align-cen" v-if="fileId">
            <div class="cancl" @click="centerDialogVisible = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
          @click="uploadTd"
            >
          确定投递
           </el-button>
        </div>
    </div>
</el-dialog>
   </div>
</template>
<script>
import {softList,enjobClassify,jobList,jobResume} from "@/api/enterprise/index" // 配置详情、岗位分类、岗位列表、投递简历
import debounce from '../../../utils/debounce.js' //防抖
import goTop from '@/components/goTop'
export default {
    name:'jobHunting',
     components:{
        goTop,
    },
    data () {
        return {
            uploadIs:true,
            activeName:'',
            loading:false,
            jobId:'',
            classifyId:'',
            workplaceName:'',
            hiringNeedsName:'',
            fileId:'',
            fileName:'',
            resoceUrl:'',
            centerDialogVisible:false,
            totalCount:0,
            workplace:['北京','南京','济南','西安','呼和浩特','沈阳','长沙','鄂尔多斯'],
            hiringNeeds:['社招','校招'],
            jobClass:[],
            jobList:[],
            search:'',
            currentNav0:'-1',
            currentNav1:'-1',
            currentNav2:'-1',
             list:{
                logo:'',
                title1:'',
                title1s:'',
                address:''
            },
            fileList:[]
        }
    },
    created () {
         document.title = "人才招聘"
        this.getDetail()
        this.getClass()
        this.getJobList()
    },
    methods: {
        // 简历上传限制其他文件
        beforeUpload(file){
         this.uploadIs = true
        let acceptArr = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/msword",
            "application/vnd.ms-powerpoint"
            ]
            const isVideo = acceptArr.includes(file.type)

            const isLt1M = file.size / 1024 / 1024 < 500
            if (!isVideo) {
            this.uploadIs = false
             this.$util.Notifi("请上传正确的文件格式",'error','fa-exclamation-circle');
            }
            if (!isLt1M) {
            setTimeout( () => {
                 this.$util.Notifi("上传文件大小不能超过 500MB!",'error','fa-exclamation-circle');
            }, 10)
            }
            return isLt1M && isVideo
        },

        // 打开人才详情
        openDetail(id){
             const newurl = this.$router.resolve({name:'jobDetail', query: {id:id}})
             window.open(newurl.href,'_blank')
        },
        // 投递
        uploadTd(){
             this.loading = true
            let params = {
                jobId:this.jobId,
                name:this.fileName,
                fileId:this.fileId
            }
               jobResume(params,'enterprise')
                .then(res => {
                     this.loading = false
                    if(res.code == 0){
                       this.$util.Notifi('投递成功','success','fa-check');
                       this.centerDialogVisible = false
                    }else{
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                })
                .catch(err => {  
                     this.loading = false                
                })
        },
        // 打开简历投递
        openTd(id){
            this.uploadIs = true
            this.jobId = id
            this.fileList = []
             this.fileId = ''
            this.fileName = ''
            this.resoceUrl = ''
            this.centerDialogVisible = true
        },
         handleAvatarSuccess1(res,file){
            this.fileId = res.data.fileId
            this.fileName = res.data.fileName
            this.resoceUrl = res.data.url
            // this.$refs.ruleForm.clearValidate('resourceUrl')
          },
        // 文件上传失败
        uploadError(){
             let errorInfo = JSON.parse(err["message"])
            this.message.error('文件上传失败，原因：' + errorInfo.message) 
        },
                 handleChangePic(file,fileList){
                    
                         if (fileList.length > 0) {
                                        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
                                        console.log(this.fileList)
                         }
                    },
        // 筛选
        datafillter(i,data,type){
            this[`currentNav${type}`]  = i
            type == 0 ? this.workplaceName = data : type == 1 ? this.hiringNeedsName = data :  this.classifyId = data.id 
            this.getJobList()
        },
        datafillter1(i,data,type){
            this[`currentNav${type}`]  = i
            type == 0 ? this.workplaceName = '' : type == 1 ? this.hiringNeedsName = '' :  this.classifyId = ''
            this.getJobList()
        },
          // 获取详情
          getDetail(){
            this.platformAppContentList = []
              softList({id:6},'enterprise')
                .then(res => {
                 res.data.forEach(item =>{
                     if(item.attributeName == "logo")   this.list.logo  = item.attributeValue
                    if(item.attributeName == "title1")  this.list.title1  = item.attributeValue
                    if(item.attributeName == "title1s") this.list.title1s  = item.attributeValue
                 })
                })
                .catch(err => {                  
                })
        },
        // 获取分类
          getClass(){
              enjobClassify({officialType:2},'enterprise')
                .then(res => {
                this.jobClass = res.data
                })
                .catch(err => {                  
                })
        },
        // 获取岗位列表
        getJobList(){
            jobList({
                classifyId:this.classifyId || '',
                workplace:this.workplaceName || '',
                hiringNeeds:this.hiringNeedsName || '',
                searchContent:this.search,
                officialType:2
            },'enterprise')
                .then(res => {
                this.jobList = res.data
                this.totalCount = res.data.length || 0
                })
                .catch(err => {                  
                })
        },
    },
}
</script>
<style lang="scss" scoped>
.formUp{
    text-align: center;
    .subBtn{
        justify-content: center;
        margin-top: 30px;
        div{
       margin-right: 30px;
       width: 140px;
        height: 40px;
        border-radius: 2px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        }
        .cancl{
            background: #F4F4F4;
            border: 1px solid #E1E1E1;
            color: #1A1A1A;
        }
        .subTd{
            color: #fff;
            background: #007EFF;
            margin-right: 30px;
       width: 140px;
        height: 40px;
        border-radius: 2px;
        text-align: center;
        cursor: pointer;
        }
    }
}
.jobHunting{
         .item-gradient{
        display: none;
    }
    .banner-img{
            width: 100%;
            height: 396px;
            object-fit: cover;
        }
    .banner{
        position: absolute;
        top:0px;
        width: 100%;
        height: 396px;
           .banner-description{
            position: absolute;
            left: 15%;
            top: 45%;
            color: #fff;
            .name{
                color: #171717;
                font-size: 40px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #171717;
                line-height: 50px;
            }
            .description{
                font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #171717;
            line-height: 50px;
            }
                .btn{
                    margin-top: 20px;
                    max-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 18px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 5px;
                    margin-right: 20px;
                    padding: 5px 0;
                    color: #323233;
                    a{
                        color: #323233;
                    }
                }
                 .btn:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #FFFFFF;
                    a{
                       color: #FFFFFF; 
                    }
                 }
    }
    }
    .jobHunting-container{
        width: 70vw;
        margin: 50px auto;
        .jobHunting-container-fillter{
            margin: 30px 0;
            .fillter-row{
                 font-size: 16px;
                 color: #0E0E0E;
                 margin-bottom: 15px;
                .allWork{
                    margin: 0 30px;
                    cursor: pointer;
                }
                .active{
                 color: #2F54EB;
                }
                .active1{
                 color: #2F54EB;
                }
                .active2{
                 color: #2F54EB;
                }
                .work{
                    margin-right: 20px;
                    cursor: pointer;
                }
            }
        }
        .coll{
            margin: 30px 0;
            .coll-alljob{
                color: #0E0E0E;
                font-size: 14px;
                margin-bottom: 10px;
            }
            .job-name{
                font-size: 18px;
                font-family: 'Microsoft YaHei';
                font-weight: bold;
                color: #0E0E0E
            }
            .job-type{
                padding-top: 10px;
                color: #0E0E0E;
                font-size: 14px;
                .job-work{
                    margin-left: 10px;
                    i{
                        color: #BFBFBF;
                    }
                }
            }
            .job-price{
                 font-size: 16px;
                font-family:'Microsoft YaHei';
                font-weight: 500;
                color: red;
                position: absolute;
                right: 60px;
                bottom: 50px;
            }
            .job-time{
                font-size: 14px;
                font-family:'Microsoft YaHei';
                font-weight: 400;
                color: #989898;
                position: absolute;
                right: 20px;
                bottom: 20px;
            }
            .job-desc{
                .job-desc-tit{
                    font-size: 14px;
                    font-family: 'Microsoft YaHei';
                    font-weight: 400;
                    color: #1A1A1A;
                }
                .job-desc-data{
                    padding: 20px 0;
                }
            }
            .job-btn{
                width: 150px;
                height: 32px;
                background: #2F54EB;
                border-radius: 2px;
                color: #fff;
                line-height: 32px;
                text-align: center;
                margin-top: 20px;
                cursor: pointer;
            }
            .job-detail{
                position: absolute;
                 right: 20px;
                bottom: 20px;
                color: #2F54EB;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}
@media (max-width: 640px){
         .banner{display: none;}
        .banner-img{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
       .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
         .endowloadDetail-description-btn{
            justify-content: space-evenly;;
                div{
                     min-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 15px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 10px;
                   margin-top: 10px;
                    padding: 5px 0;
                    a{
                        color: #000;
                    }
                }
              
                 div:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #fff;
                    
                 }
            }
       }
    }
    #jobHunting{
         .banner-img{
            height: auto;
         }
         .jobHunting-container{
            width: 90%;
            .fillter-row{
                flex-wrap: wrap;
                font-size: 14px;
            }
                            .job-work{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 200px;
                }
                .job-time{
                    bottom: 5px !important;
                    right: 10px;
                }
                .job-price{
                    bottom: 70px;
                    right: 10px;
                }
         }
    }
}
::v-deep{
   @media (max-width: 640px){
     .el-collapse-item__header{
         padding: 30px 10px !important;
     }
     .el-dialog{
        width: 90% !important;
        .el-upload-dragger{
            width: 300px !important;
        }
     }
   } 
    .el-input__inner{
        border: 1px solid #E6E6E6;
border-radius: 20px 0 0 20px;
border-right: none;
    }
 .el-input-group__append{
border: 1px solid #E6E6E6;
border-radius: 0 20px 20px 0;
background: #2F54EB;
color: #fff;
padding: 0 30px;
cursor: pointer;
 }
 .el-collapse-item__header{
   display: block;
    height: auto;
    line-height: normal;
    position: relative;
    padding: 30px;
    .el-collapse-item__arrow{
        position: absolute;
        right: 20px;
        top:50px
    }
 }
 .el-collapse-item__content{
    background: #FAFAFA;
    padding: 20px 30px;
    position: relative;
 }
}
</style>